import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { ValidationService } from 'app/core/services/validation/validation.service';
import { environment } from '@environments/environment';
import { DropdownListTextItem } from 'app/models/dropdownListTextItem';
import { ICanCancel, ITriggerOnClose } from 'app/core/services/custom-window-service/custom-window.service';
import {
  CreateFeedbackInput,
  CreateFeedbackInputKategorie,
  CreateFeedbackInputPrioritaet,
  CreateFeedbackInputTyp,
  ObjektDatenKey,
  ObjektTyp
} from 'app/core/services/api-client/api-client';
import { EnumHelper } from 'app/core/utils/EnumHelper';
import { ToastService } from 'app/core/services/toast-service';
import { SharedFeedbackService } from '../../services/shared-feedback.service';
import { GenericUploadErrorEvent, UploadFile, UploadFileState } from 'app/shared/components/generic-upload';
const {
  KeinePassendeKategorie,
  Dublette,
  Strukturformel,
  Registriername,
  SonstigerInhaltlicherFehler,
  HinweisZumZitat
} = { ...CreateFeedbackInputKategorie };

@Component({
  selector: 'app-stofffeedback-view',
  templateUrl: './stoff-feedback.component.html',
})
export class StoffFeedbackComponent implements ICanCancel, ITriggerOnClose {
  
  public files: UploadFile[] = [];
  public uploadUrl: string = environment.baseAPIUrl + environment.feedback + 'anhang/save';

  @Input()
  public createFeedback = new CreateFeedbackInput({ 
    typ: CreateFeedbackInputTyp.Stoffdaten,
    objekt: new ObjektDatenKey({ typ: ObjektTyp.Stoff }),
    kategorie: CreateFeedbackInputKategorie.KeinePassendeKategorie,
    prioritaet: CreateFeedbackInputPrioritaet.Normal
  });
  public categoryListItems = [KeinePassendeKategorie, Dublette, Strukturformel, Registriername, SonstigerInhaltlicherFehler, HinweisZumZitat];
  public categoryItems: DropdownListTextItem[];
  public priorityListItems = EnumHelper.ToArray(CreateFeedbackInputPrioritaet);
  public priorityItems: DropdownListTextItem[];
  @Output()
  public closeWindow = new EventEmitter<CreateFeedbackInput>();

  constructor(
    private sharedFeedbackService: SharedFeedbackService,
    private i18n: I18nService,
    private validationService: ValidationService,
    private readonly toastyService: ToastService,
  ) {
    this.setCategoryItems();
    this.setPriorityItems();

    this.createFeedback.beschreibung = '';
    this.createFeedback.kategorie = CreateFeedbackInputKategorie.KeinePassendeKategorie;
    this.createFeedback.prioritaet = CreateFeedbackInputPrioritaet.Normal;
    this.createFeedback.verweise = [];
    this.createFeedback.url = window.location.href;
    this.createFeedback.typ = CreateFeedbackInputTyp.Stoffdaten;
  }

  public setCategoryItems(): void {
    this.categoryItems = [];
    this.categoryListItems.forEach((key: string) => {
      this.categoryItems.push({
        text: this.i18n.getLocalizedString('feedback.kategorien.' + key),
        value: key,
      });
    });
  }

  public setPriorityItems(): void {
    this.priorityItems = [];
    this.priorityListItems.forEach((key: string) => {
      this.priorityItems.push({
        text: this.i18n.getLocalizedString('feedback.prioritaeten.' + key),
        value: key,
      });
    });
  }

  public onError(event: GenericUploadErrorEvent) {
    if (event.response) {
      event.file.errorMessage = this.toastyService.getErrorMessage(event.response);
      this.toastyService.toastError(event.response);
    }
  }  

  public async send() {
    try {
      this.createFeedback.anhaenge = this.files
        .filter(f => f.state === UploadFileState.Completed && f.response && f.response.anhangUid)
        .map(f => f.response.anhangUid);
      await this.sharedFeedbackService.create(this.createFeedback).toPromise();
      this.toastyService.toastSuccessFormatted(
        'feedback.messages.createSuccess.title',
        'feedback.messages.createSuccess.message',
        {},
      );
      this.closeWindow.emit(this.createFeedback);
    } catch {}    
  }

  public async cancel() {
    this.closeWindow.emit(this.createFeedback);
  }

  public get canSend() {
    return (
      !this.validationService.isNullOrEmpty(this.createFeedback.kategorie) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.prioritaet) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.beschreibung) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.objekt.id) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.merkmalName) &&
      !this.validationService.isNullOrEmpty(this.createFeedback.merkmalId)
    );
  }

  public get title(): string {
    return this.i18n.getLocalizedString(`feedback.titles.${this.createFeedback.objekt.typ}`);
  }
}
